import { TableCell, TableRow } from '@mui/material';
import {
  calcItemRows,
  CategoryResultTable,
  ItemResultTable,
  style,
  TypeResultTable,
} from '../ResultTable';
import { isEmptyData } from '../../../_utils/utils';
import { getColorByLabel } from '../../../_utils/inspectionUtils';

export type Depth0RowProps = {
  category: CategoryResultTable;
  type: TypeResultTable;
  item: ItemResultTable;
  typeIndex: number;
  itemIndex: number;
  tableStyle: style;
};
/** 0層目までの小項目1行分 */
const Depth0Row: React.FC<Depth0RowProps> = ({
  category,
  type,
  item,
  typeIndex,
  itemIndex,
  tableStyle,
}) => {
  return (
    <TableRow>
      {typeIndex === 0 && itemIndex === 0 && (
        <TableCell
          sx={tableStyle.category}
          rowSpan={category.typeResultList.reduce((rows, type) => {
            return rows + calcItemRows(type.itemResultList);
          }, 0)}
        >
          {category.label}
        </TableCell>
      )}
      {itemIndex === 0 && (
        <TableCell
          sx={tableStyle.type}
          rowSpan={calcItemRows(type.itemResultList)}
        >
          {type.label}
        </TableCell>
      )}
      <TableCell colSpan={3} sx={tableStyle.item}>
        {item.label}
      </TableCell>
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(item.inResult),
        }}
        colSpan={isEmptyData(item.inNumericalValue) ? 2 : 1}
      >
        {item.inResult}
      </TableCell>
      {!isEmptyData(item.inNumericalValue) && (
        <TableCell sx={tableStyle.result}>{item.inNumericalValue}</TableCell>
      )}
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(item.qcResult),
        }}
        colSpan={isEmptyData(item.qcNumericalValue) ? 2 : 1}
      >
        {item.qcResult}
      </TableCell>
      {!isEmptyData(item.qcNumericalValue) && (
        <TableCell sx={tableStyle.result}>{item.qcNumericalValue}</TableCell>
      )}
    </TableRow>
  );
};

export default Depth0Row;
